import * as React from 'react';
import * as types from '../../types';
import * as services from '../../services';
import MainSaveForm from './MainSaveForm';
// import MainImportForm from './MainImportForm';
import { FilteredMainList } from './FilteredMainList';
import { GIAAImport, IEntity } from '../../types';
import { IUpdatesListColumn, ColumnDisplayTypes } from '../../types/UpdatesListColumn';
import { CrLoadingOverlay } from '../cr/CrLoadingOverlay';
import { IColumn, IObjectWithKey, Selection } from '@fluentui/react/lib/DetailsList';
import { ConfirmDialog } from '../cr/ConfirmDialog';
import { MessageDialog } from '../cr/MessageDialog';
import styles from '../../styles/cr.module.scss';
import withScreenSizeDetector from '../withScreenSizeDetector';
import { ScreenSize } from '../useScreenSizeDetector';
import { IUseUserContextProps } from '../useUserContext';


export interface IMainListProps extends types.IBaseComponentProps {
    isArchive: boolean;
    dgAreaId: number | string;
    incompleteOnly: boolean;
    onChangeIncompleteOnly: (value: boolean) => void;
    justMine: boolean;
    onChangeJustMine: (value: boolean) => void;
    filterText?: string;
    onChangeFilterText: (value: string) => void;
    onItemTitleClick: (ID: number, title: string, filteredItems: any[]) => void;
    onMainSaved: () => void;
    mainListsSaveCounter: number;
    onCheckUpdatesRequest: () => void;
    superUserPermission: boolean;
    updatesReqInProgress: boolean;
    screenSize: ScreenSize;
    orbUserContext: IUseUserContextProps;
}

export interface IMainListState<T> {
    SelectedEntity: number;
    SelectedEntityTitle: string;
    SelectedEntityChildren: number;
    ShowForm: boolean;
    ShowImportForm: boolean;
    EnableEdit?: boolean;
    EnableDelete?: boolean;
    HideDeleteDialog: boolean;
    HideDeleteDisallowed: boolean;
    ShowChildForm: boolean;
    CurrentPage?: number;
    NextPageAvailable?: boolean;
    Entities: T[];
    Loading: boolean;
    ListFilterText?: string;
    InitDataLoaded: boolean;
}
export class MainListState<T> implements IMainListState<T> {
    public SelectedEntity = null;
    public SelectedEntityTitle: string = null;
    public SelectedEntityChildren = null;
    public ShowForm = false;
    public ShowImportForm = false;
    public HideDeleteDialog = true;
    public HideDeleteDisallowed = true;
    public EnableEdit = false;
    public EnableDelete = false;
    public ShowChildForm = false;
    public CurrentPage = 1;
    public NextPageAvailable = false;
    public Entities: T[] = [];
    public Loading = false;
    public ListFilterText = null;
    public InitDataLoaded = false;
}

class MainList extends React.Component<IMainListProps, IMainListState<IEntity>> {
    private _selection: Selection;
    private mainService: services.GIAAAuditReportService = new services.GIAAAuditReportService();
    private gIAAImportService: services.GIAAImportService = new services.GIAAImportService();

    private ChildEntityName: { Plural: string, Singular: string } = { Plural: 'Recommendations', Singular: 'Recommendation' };

    private listColumns: IUpdatesListColumn[] = [
        //use fieldName as key
        {
            key: 'ID',
            name: 'ID',
            fieldName: 'ID',
            minWidth: 1,
            isResizable: true,
            columnDisplayType: ColumnDisplayTypes.Hidden,
        },
        {
            key: 'NumberStr',
            name: 'Num',
            fieldName: 'NumberStr',
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            isMultiline: true,
            headerClassName: styles.bold,
        },
        {
            key: 'Title',
            name: 'Title',
            fieldName: 'Title',
            minWidth: 230,
            maxWidth: 230,
            isResizable: true,
            isMultiline: true,
            headerClassName: styles.bold,
        },
        {
            key: 'Directorate',
            name: `${this.props.orbUserContext.orbConfig.OrgL2Label}(s)`,
            fieldName: 'Directorate',
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
            isMultiline: true,
            isCollapsible: true,
            headerClassName: styles.bold,
        },

        {
            key: 'IssueDateStr',
            name: 'Issue Date',
            fieldName: 'IssueDateStr',
            minWidth: 85,
            maxWidth: 85,
            isResizable: true,
            isCollapsible: true,
            headerClassName: styles.bold,
        },
        {
            key: 'Year',
            name: 'Year',
            fieldName: 'Year',
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            isCollapsible: true,
            headerClassName: styles.bold,
        },

        {
            key: 'CompletePercent',
            name: 'Completed',
            fieldName: 'CompletePercent',
            minWidth: 70,
            maxWidth: 70,
            isResizable: true,
            isCollapsible: true,
            headerClassName: styles.bold,
        },

        {
            key: 'AssignedTo',
            name: 'Action Owners',
            fieldName: 'AssignedTo',
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
            isMultiline: true,
            isCollapsible: true,
            headerClassName: styles.bold,
        },

        {
            key: 'UpdateStatus',
            name: 'ReqUpdFrom',
            fieldName: 'UpdateStatus',
            minWidth: 90,
            maxWidth: 90,
            isResizable: true,
            isCollapsible: true,
            headerClassName: styles.bold,
        },

        {
            key: 'Assurance',
            name: 'Assurance',
            fieldName: 'Assurance',
            minWidth: 82,
            maxWidth: 82,
            isResizable: true,
            isCollapsible: true,
            headerClassName: styles.bold,
        },

    ];

    constructor(props: IMainListProps, state: IMainListState<IEntity>) {
        super(props);
        this.state = new MainListState<IEntity>();

        this._selection = new Selection({
            onSelectionChanged: () => {
                if (this._selection.getSelectedCount() === 1) {
                    const sel = this._selection.getSelection()[0];
                    console.log(sel);
                    const key = Number(sel.key);
                    const title: string = sel["Title"];
                    this.setState({ SelectedEntity: key, SelectedEntityTitle: title, EnableEdit: true, EnableDelete: true });
                }
                else {
                    this.setState({ SelectedEntity: null, SelectedEntityTitle: null, EnableEdit: false, EnableDelete: false });
                }
            }
        });
    }

    //#region Render

    public render(): React.ReactElement<IMainListProps> {

        return (
            <div className={`${styles.cr}`}>
                <div style={{ position: 'relative' }}>
                    <CrLoadingOverlay isLoading={this.state.Loading} />
                    {this.renderList()}
                    {this.state.ShowForm && this.renderForm()}
                    {this.state.ShowImportForm && this.renderImportForm()}

                    <MessageDialog hidden={this.state.HideDeleteDisallowed} title={`This report cannot be deleted`} content={`Audit Report '${this.getSelectedEntityName()}' has ${this.state.SelectedEntityChildren} ${this.state.SelectedEntityChildren === 1 ? this.ChildEntityName.Singular.toLowerCase() : this.ChildEntityName.Plural.toLowerCase()} belonging to it.`} handleOk={this.toggleDeleteDisallowed} />
                    <ConfirmDialog hidden={this.state.HideDeleteDialog} title={`Are you sure you want to delete ${this.getSelectedEntityName()}?`} content={`A deleted record cannot be un-deleted.`} confirmButtonText="Delete" handleConfirm={this.deleteRecord} handleCancel={this.toggleDeleteConfirm} />
                </div>
            </div>
        );
    }

    private adjustColumnWidthsForScreenSize(columns: IUpdatesListColumn[]): IUpdatesListColumn[] {
        const { isMediumScreen, isLargeScreen, isMobile } = this.props.screenSize;

        // Create a new copy of the columns array
        return columns.map((column) => {
            let adjustedColumn = { ...column };

            // Adjust widths based on screen size
            if (isMediumScreen) {
                if (column.key === 'Title') {
                    adjustedColumn.minWidth = 170;
                    adjustedColumn.maxWidth = 170;
                }
                if (column.key === 'IssueDateStr') {
                    adjustedColumn.minWidth = 70;
                    adjustedColumn.maxWidth = 70;
                }
                if (column.key === 'Year') {
                    adjustedColumn.minWidth = 40;
                    adjustedColumn.maxWidth = 40;
                }
                if (column.key === 'Directorate') {
                    adjustedColumn.minWidth = 100;
                    adjustedColumn.maxWidth = 100;
                }
                if (column.key === 'AssignedTo') {
                    adjustedColumn.minWidth = 100;
                    adjustedColumn.maxWidth = 100;
                }

            } else if (isMobile) {
                if (column.key === 'Title') {
                    adjustedColumn.minWidth = 230;
                    adjustedColumn.maxWidth = 230;
                }
            } else if (isLargeScreen) {
                // Revert to default for large screens
                if (column.key === 'Title') {
                    adjustedColumn.minWidth = 230;
                    adjustedColumn.maxWidth = 230;
                }
                if (column.key === 'IssueDateStr') {
                    adjustedColumn.minWidth = 85;
                    adjustedColumn.maxWidth = 85;
                }
                if (column.key === 'Year') {
                    adjustedColumn.minWidth = 80;
                    adjustedColumn.maxWidth = 80;
                }
                if (column.key === 'Directorate') {
                    adjustedColumn.minWidth = 120;
                    adjustedColumn.maxWidth = 120;
                }
                if (column.key === 'AssignedTo') {
                    adjustedColumn.minWidth = 120;
                    adjustedColumn.maxWidth = 120;
                }
            }

            return adjustedColumn;
        });
    }


    private renderList() {
        const listColumns = this.getColumns();
        const listColumnsForData = this.getColumnsForData();

        const adjustedListColumns = this.adjustColumnWidthsForScreenSize(listColumns);

        let items: IObjectWithKey[] = this.state.Entities.map((e) => { return this.makeItem(e, listColumnsForData); });

        return (
            <FilteredMainList
                onItemTitleClick={this.props.onItemTitleClick}
                columns={adjustedListColumns}
                items={items}
                incompleteOnly={this.props.incompleteOnly}
                onChangeIncompleteOnly={this.props.onChangeIncompleteOnly}
                justMine={this.props.justMine}
                onChangeJustMine={this.props.onChangeJustMine}
                filterText={this.props.filterText}
                onFilterChange={this.props.onChangeFilterText}
                selection={this._selection}
                onAdd={this.addItem}
                onImport={this.importItems}
                onCheckUpdatesReq={this.props.onCheckUpdatesRequest}
                onEdit={this.editItem}
                onDelete={this.checkDelete}
                editDisabled={!this.state.EnableEdit}
                deleteDisabled={!this.state.EnableDelete}
                superUserPermission={this.props.superUserPermission}
                updatesReqInProgress={this.props.updatesReqInProgress}
            />
        );
    }

    private renderForm() {

        return (
            <MainSaveForm
                showForm={this.state.ShowForm}
                entityId={this.state.SelectedEntity}
                onSaved={this.formSaved}
                onCancelled={this.closePanel}
                {...this.props}
            />
        );

    }

    private renderImportForm() {
        return null;
        // return (
        //     <MainImportForm
        //         showForm={this.state.ShowImportForm}
        //         onSaved={this.formSaved}
        //         onCancelled={this.closePanel}
        //         {...this.props}
        //     />
        // );
    }

    //#endregion Render

    //#region Class Methods

    private makeItem = (e: IEntity, listColumns: IUpdatesListColumn[]): any => {

        let item: any = { key: e["ID"] };

        listColumns.map((c) => {
            let fieldContent: string = String(e[c.fieldName]);
            item = {
                [c.fieldName]: fieldContent,
                ...item
            };
        });
        return item;
    }

    private getColumns(): IUpdatesListColumn[] {

        let listColumns: IUpdatesListColumn[];
        listColumns = this.listColumns.filter(c => c.columnDisplayType !== ColumnDisplayTypes.Hidden);
        return listColumns;
    }

    private getColumnsForData(): IUpdatesListColumn[] {
        //separate method for data because we want to add Hidden Columns in the data, so hidden columns data can be filtered
        const listColumns: IUpdatesListColumn[] = this.listColumns;
        return listColumns;
    }

    private closePanel = (): void => {
        this.setState({ ShowForm: false, ShowImportForm: false });
    }

    private formSaved = (): void => {
        this.setState({ ShowForm: false, ShowImportForm: false }, this.props.onMainSaved);
    }

    private getSelectedEntityName = (): string => {
        let entity = this.state.Entities.filter((e) => { return e.ID === this.state.SelectedEntity; });
        return entity[0] ? entity[0].Title : null;
    }

    private deleteRecord = (): void => {

        this.setState({ HideDeleteDialog: true });
        if (this.state.SelectedEntity) {
            this.mainService.delete(this.state.SelectedEntity).then(this.loadData, (err) => {
                if (this.props.errorHandling?.onError) this.props.errorHandling?.onError(`Error deleting item ${this.state.SelectedEntity}`, err.message);
            });
        }
    }

    //#endregion Class Methods

    //#region Data Load


    private loadData = (): void => {
        this.setState({ Loading: true });
        const read: Promise<IEntity[]> = this.mainService.readAllWithFilters(this.props.dgAreaId, this.props.incompleteOnly, this.props.justMine, this.props.isArchive);
        read.then((entities: any): void => {
            this.setState({
                Loading: false, Entities: entities,
            });

        }, (err) => this.errorLoadingData(err));
    }
    private errorLoadingData = (err: any, entityName?: string): void => {
        this.setState({ Loading: false });
        if (this.props.errorHandling?.onError) this.props.errorHandling?.onError(`Error loading ${entityName || 'items'}`, err.message);
    }
    public componentDidMount(): void {
        this.loadData();
    }
    public componentDidUpdate(prevProps: IMainListProps): void {
        if (prevProps.dgAreaId !== this.props.dgAreaId || prevProps.justMine !== this.props.justMine || prevProps.incompleteOnly !== this.props.incompleteOnly || prevProps.mainListsSaveCounter !== this.props.mainListsSaveCounter) {
            this._selection.setAllSelected(false);
            this.loadData();
        }
    }


    //#endregion Data Load

    //#region Events Handlers

    private addItem = (): void => {
        if (this.state.SelectedEntity)
            this._selection.setKeySelected(this.state.SelectedEntity.toString(), false, false);
        this.setState({ SelectedEntity: null, ShowForm: true });
    }
    private importItems = (): void => {
        if (this.state.SelectedEntity)
            this._selection.setKeySelected(this.state.SelectedEntity.toString(), false, false);
        this.setState({ SelectedEntity: null, ShowImportForm: true });
    }

    private editItem = (): void => {
        this.setState({ ShowForm: true });
    }
    private checkDelete = (): void => {

        this.mainService.entityChildren(this.state.SelectedEntity, 'GIAARecommendations', 'GIAARecommendations').then((children) => {
            if (children.length > 0) {
                this.setState({ SelectedEntityChildren: children.length }, this.toggleDeleteDisallowed);
            }
            else {
                this.toggleDeleteConfirm();
            }
        });
    }

    private toggleDeleteDisallowed = (): void => {
        this.setState({ HideDeleteDisallowed: !this.state.HideDeleteDisallowed });
    }
    private toggleDeleteConfirm = (): void => {
        this.setState({ HideDeleteDialog: !this.state.HideDeleteDialog });
    }

    //#endregion Events Handlers

}

export default withScreenSizeDetector(MainList);